module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Magic-d8a6a1d4108a6f2bb849bf464e56b8f2.svg";